import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "step-title tw-text-[#211f58] tw-text-center tw-text-[16px] tw-font-normal tw-ml-[10px]" }
const _hoisted_2 = {
  key: 0,
  class: "detail tw-flex tw-p-[25px] tw-gap-[20px] tw-bg-white tw-flex-col"
}
const _hoisted_3 = {
  key: 1,
  class: "row"
}
const _hoisted_4 = { class: "col-sm-5 tw-font-medium tw-text-[14px]" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "tw-ml-1 tw-text-[#F7553C]" }, "*", -1)
const _hoisted_6 = { class: "col-sm-7" }
const _hoisted_7 = {
  key: 1,
  class: "detail tw-flex tw-p-[35px] tw-gap-[30px] tw-bg-white tw-flex-col"
}
const _hoisted_8 = { class: "tw-flex tw-flex-col tw-gap-[35px] tw-items-start md:tw-flex-row md:tw-items-center" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "tw-gap-[12px] tw-flex tw-flex-col" }
const _hoisted_11 = { class: "title-detail-step tw-text-[#211f58] tw-text-[18px] tw-font-medium tw-leading-[145%]" }

import { getComponentUiText } from "@/utils/utilities";
import { reactive, watch } from "vue";
import DraggableIcon from "@/components/svgs/draggableIcon.vue";
import ArrowDownTableIcon from "@/components/svgs/arrowDownTableIcon.vue";
import BaseInput from "@/components/common/form/baseInput.vue";
import WYSiwygEditor from "@/components/common/wysiwygEditor.vue";
import customDescriptionContent from "@/components/common/customDescriptionContent.vue";
import ButtonShowMore from "@/components/common/setting/buttonShowMore.vue";
import CustomDropDownItem from "@/components/common/customDropDownItem.vue";
import { useVuelidate } from "@vuelidate/core";
import { any } from "joi";
import { helpers, required } from "@vuelidate/validators";
import store from "@/store";

export default /*#__PURE__*/_defineComponent({
  __name: 'listStep',
  props: {
  inModalAdd: {
    type: Boolean,
    required: false,
    default: false,
  },
  inModalEdit: {
    type: Boolean,
    required: false,
  },
  item: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  idItemExpand: {
    type: any,
    required: true,
  },
  checkListGroupId: {
    type: Boolean,
    required: false,
    default: false,
  },
  action: {
    type: Boolean,
    required: false,
    default: false,
  },
  isEditAction: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ["changeExpand", "RemoveStep", "handleUpdateData"],
  setup(__props, { emit: emits }) {

const props = __props;


const element = reactive({ ...props.item });
// const idItemExpand = props.idItemExpand;
const parseDescription = (data) => {
  try {
    const description = data;
    const startChar = description.slice(0, 2);
    return `data:image/${
      startChar !== "iV" ? "svg+xml" : "png"
    };base64,${description}`;
  } catch (e) {
    // description.value = data;
  }
};

watch(
  () => store.state.Recommend.isCreatingAction,
  () => {
    if (store.state.Recommend.isCreatingAction === true) {
      saveChanges();
    }
  },
);


const handleUpdateExpand = (id) => {
  emits("changeExpand", id);
};
const removeStep = (index) => {
  emits("RemoveStep", index);
};
const handleUpdateData = () => {
  element.isEdit = true;
  emits("handleUpdateData", element, props.index);
};
const handleBlurDescription = async () => {
  v$.value.checklistGroupActionHtml.$touch();
};
const rules = {
  checklistGroupActionName: {
    required: helpers.withMessage(
      () => getComponentUiText("app-setting-org-detail-required-fields-1"),
      required,
    ),
  },
  checklistGroupActionHtml: {
    required: helpers.withMessage(
      () => getComponentUiText("app-setting-org-detail-required-fields-1"),
      required,
    ),
  },
};
const v$ = useVuelidate(rules, element as any);
const saveChanges = async () => {
  await v$.value.$validate();
  store.commit("Recommend/SET_LIST_STEP_VALIDATION_STATE", {
    id: element.id,
    isValid: !v$.value.$error,
  });
};

return (_ctx: any,_cache: any) => {
  return (!element.checklistGroupActionIsArchived)
    ? (_openBlock(), _createElementBlock("div", {
        key: element.id,
        class: "tw-flex tw-w-full tw-flex-col step tw-bg-[#fcfcfd] tw-rounded-[6px] tw-mb-[25px]",
        style: _normalizeStyle(
      element.id === __props.idItemExpand ? 'box-shadow: 0 0 4px 0 #0000000d' : ''
    )
      }, [
        _createElementVNode("div", {
          style: _normalizeStyle(`${
        _unref(v$).checklistGroupActionName.$error || _unref(v$).checklistGroupActionHtml.$error
          ? 'border: 1px solid #dc3545; background-color: #fee5e2'
          : ''
      }`),
          class: "tw-flex tw-flex-row tw-items-center tw-justify-between tw-px-[25px] tw-py-[20px] step__content"
        }, [
          _createElementVNode("div", {
            class: "tw-flex tw-w-full tw-flex-row tw-items-center",
            style: _normalizeStyle(`line-height: ${__props.inModalEdit || __props.inModalAdd ? '22px' : '28px'} `)
          }, [
            (
            !__props.isEditAction ||
            __props.inModalAdd ||
            (__props.inModalEdit && (__props.checkListGroupId || __props.action))
          )
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "tw-w-2 tw-h-full",
                  style: _normalizeStyle(`cursor: ${!__props.isEditAction ? 'not-allowed' : 'pointer'}`)
                }, [
                  _createVNode(DraggableIcon, {
                    class: "drag-handle",
                    width: 8,
                    height: 12
                  })
                ], 4))
              : _createCommentVNode("", true),
            _createElementVNode("span", {
              class: _normalizeClass(`order tw-text-[#211f58] tw-text-center tw-font-semibold tw-leading-[100%] content tw-ml-[10px] ${
            __props.inModalAdd || __props.inModalEdit ? 'tw-text-[14px]' : 'tw-text-[16px]'
          }`)
            }, _toDisplayString(_unref(getComponentUiText)(
              "app-assess-recommendations-action-table-action-plan-task-1",
            )) + " " + _toDisplayString(`${__props.index + 1}${
              element.optional
                ? ` - ${_unref(getComponentUiText)(
                    "app-assess-recommendations-action-table-steps-solve-step-optional-1",
                  )}`
                : ""
            }`) + ": ", 3),
            _createElementVNode("span", _hoisted_1, _toDisplayString(element.checklistGroupActionName), 1)
          ], 4),
          (__props.inModalAdd || (__props.inModalEdit && (__props.checkListGroupId || __props.action)))
            ? (_openBlock(), _createBlock(ButtonShowMore, {
                key: 0,
                "id-popover": 'popover-btn-show-more-list-step-' + __props.index,
                "is-from-notification": true
              }, {
                default: _withCtx(() => [
                  _createVNode(CustomDropDownItem, {
                    style: 'danger',
                    "id-text": 'app-settings-domain-verify-modal-delete-button-1',
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (removeStep(__props.index)))
                  })
                ]),
                _: 1
              }, 8, ["id-popover"]))
            : _createCommentVNode("", true),
          _createVNode(ArrowDownTableIcon, {
            class: _normalizeClass([
          'arrow tw-ml-[5px]',
          element.id === __props.idItemExpand ? 'arrow-up' : 'arrow-down',
          'tw-cursor-pointer',
        ]),
            onClick: _cache[1] || (_cache[1] = 
          () => {
            if (__props.idItemExpand === element.id) {
              //   title = '';
              //   description = '';
              //   optional = false;
              //   idItemExpand = null;
              handleUpdateExpand(null);
            } else {
              //   title = element.title;
              //   description = element.description;
              //   optional = element.optional;
              //   idItemExpand = element.id;
              handleUpdateExpand(element.id);
            }
          }
        )
          }, null, 8, ["class"])
        ], 4),
        _withDirectives(_createElementVNode("div", null, [
          (__props.inModalAdd || __props.inModalEdit)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(BaseInput, {
                  modelValue: element.checklistGroupActionName,
                  "onUpdate:modelValue": [
                    _cache[2] || (_cache[2] = ($event: any) => ((element.checklistGroupActionName) = $event)),
                    _cache[3] || (_cache[3] = 
            (text) => {
              element.checklistGroupActionName = text;
              handleUpdateData();
            }
          )
                  ],
                  "read-only": __props.inModalEdit && !__props.checkListGroupId && !__props.action,
                  "class-name": `modal-edit-action-step-input`,
                  "input-class": "!tw-h-[56px]",
                  "id-focus": 'input-focus',
                  validation: _unref(v$).checklistGroupActionName,
                  "validate-on-blur": true,
                  "valid-message": 
            _unref(getComponentUiText)(
              'app-assess-recommendations-edit-action-modal-action-detail-required-1',
            )
          ,
                  placeholder: 
            _unref(getComponentUiText)(
              'app-assess-recommendations-edit-action-modal-action-detail-placeholder-1',
            )
          ,
                  label: 
            _unref(getComponentUiText)(
              'app-assess-recommendations-edit-action-modal-action-detail-title-1',
            )
          
                }, null, 8, ["modelValue", "read-only", "validation", "valid-message", "placeholder", "label"]),
                (__props.inModalAdd || (__props.inModalEdit && (__props.checkListGroupId || __props.action)))
                  ? (_openBlock(), _createBlock(BaseInput, {
                      key: 0,
                      modelValue: element.checklistGroupActionHtml,
                      "onUpdate:modelValue": [
                        _cache[6] || (_cache[6] = ($event: any) => ((element.checklistGroupActionHtml) = $event)),
                        ($event: any) => (null)
                      ],
                      validation: _unref(v$).checklistGroupActionHtml,
                      "class-name": "modal-edit-action-step-input !tw-items-start",
                      placeholder: 
            _unref(getComponentUiText)(
              'app-assess-recommendations-edit-action-modal-action-detail-placeholder-1',
            )
          ,
                      label: 
            _unref(getComponentUiText)(
              'app-assess-recommendations-edit-action-modal-action-detail-description-1',
            )
          
                    }, {
                      default: _withCtx(() => [
                        _createVNode(WYSiwygEditor, {
                          modelValue: element.checklistGroupActionHtml,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((element.checklistGroupActionHtml) = $event)),
                          validate: _unref(v$).checklistGroupActionHtml.$error,
                          "include-image": false,
                          "onUpdate:blur": handleBlurDescription,
                          "onUpdate:value": _cache[5] || (_cache[5] = 
              (text) => {
                element.checklistGroupActionHtml = text;
                handleUpdateData();
              }
            )
                        }, null, 8, ["modelValue", "validate"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "validation", "placeholder", "label"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
                "app-assess-recommendations-edit-action-modal-action-detail-description-1",
              )) + " ", 1),
                        _hoisted_5
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(customDescriptionContent, {
                          description: element.checklistGroupActionHtml
                        }, null, 8, ["description"])
                      ])
                    ]))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createTextVNode(_toDisplayString(element.checklistGroupActionImages[0]?.checklistGroupActionImageFile) + " ", 1),
                  _createElementVNode("img", {
                    src: 
              parseDescription(
                element.checklistGroupActionImages[0]
                  ?.checklistGroupActionImageFile,
              )
            ,
                    alt: "",
                    class: "tw-max-w-[225px] lg:tw-max-w-[320px]"
                  }, null, 8, _hoisted_9),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(customDescriptionContent, {
                        description: element.checklistGroupActionHtml
                      }, null, 8, ["description"])
                    ])
                  ])
                ])
              ]))
        ], 512), [
          [_vShow, element.id === __props.idItemExpand]
        ])
      ], 4))
    : _createCommentVNode("", true)
}
}

})